import React from 'react';
import { Form } from 'react-bootstrap';

import { Article, Brand, CTA, Feature, Navbar } from './components/index';
import { Footer, Blog, Possibility, Features, WhatGPT3, Header } from './containers/index';

import './App.css';



const App = () => {
    return (
        <div className="App">
            <div className="gradient__bg">
                <Navbar />
                <Header />
            </div>
            <Brand />
            <WhatGPT3 />
            <Features />
            <Possibility />
            <CTA />
            <Blog />
            <Footer />
        </div>
    )
}

export default App
